"use client"

import { useState } from "react"

import type { ShopifySearchFiltersData } from "~/hooks/useShopifyCollectionProducts"
import { PanelFilters } from "~/components/ui/Collection/CollectionDefault/components/PanelFilters/index.client"
import InlineCta from "~/components/ui/InlineCta"
import Icon from "~/components/abstracts/Icon"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { useSearchAndDiscoveryContext } from "~/providers/SearchAndDiscoveryProvider"

import { sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"

export function PanelFiltersTrigger({ facets }: Pick<ShopifySearchFiltersData, "facets">) {
  const t = useTranslate()
  const [isPanelOpen, setIsPanelOpen] = useState<boolean>(false)
  const { filtersCount, reset } = useSearchAndDiscoveryContext()

  return (
    <>
      <div className={css.link}>
        <Icon name="Filters" width={18} className={sprinkles({ marginRight: 5 })} />
        <InlineCta
          onClick={() => {
            setIsPanelOpen(true)
          }}
          customLineActive={true}
          weight="semiBold"
          fontFamily="spezia"
          transform="uppercase"
          className={sprinkles({ fontSize: 15, letterSpacing: 0.4, lineHeight: 1 })}
          data-abtest="PLP/CTA/Filters"
        >
          {t("filters_title")}
        </InlineCta>
        {filtersCount > 0 && <span className={css.indicator}>{filtersCount}</span>}
      </div>
      {filtersCount > 0 && (
        <InlineCta customLineActive={true} onClick={reset} className={sprinkles({ marginLeft: 5 })}>
          {t("filters_reset")}
        </InlineCta>
      )}
      <PanelFilters facets={facets} open={isPanelOpen} onOpenChange={setIsPanelOpen} />
    </>
  )
}
